module.exports = __webpack_public_path__ + "static/media/logo.5f7a8064.jpg";